<template>
	<div class="overlay">
		<div class="text-overlay">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Overlay',
};
</script>

<style scoped>
.overlay {
	background-color: #000;
	border-radius: 4px;
	bottom: 0;
	height: 100%;
	left: 0;
	opacity: .9;
	position: absolute;
	right: 0;
	top: 0;
	width: 100%;
}

.text-overlay {
	color: #fff;
	font-size: 14px;
	left: 50%;
	/* padding: 10px; */
	position: absolute;
	text-align: center;
	top: 50%;
	transform: translate(-50%, -50%);
}
</style>
